import { SET_BUFFER_DISTANCE, SET_BUFFER_UNIT } from '../../constants/appTypes';

const initialState: { unit: string; distance: number } = { unit: 'meters', distance: 1 };

interface bufferAction {
  unit: string;
  distance: number;
  type: string;
}

export function buffer(state = initialState, action: bufferAction) {
  switch (action.type) {
    case SET_BUFFER_DISTANCE:
      state.distance = action.distance;
      return state;
    case SET_BUFFER_UNIT:
      state.unit = action.unit;
      return state;
    default:
      return state;
  }
}

export default buffer;
